import { LAYOUTS, POSITION, } from '@voltmoney/types';
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, DocumentPickerState, FontFamilyTokens, FontSizeTokens, HeaderTypeTokens, IconSizeTokens, IconTokens, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackType, StepperTypeTokens, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { ACTION } from './types';
import { horizontalStepperRepo } from '../../../configs/utils';
import { documentPickerAction, GoBackAction, onPageLoad, triggerAction, } from './actions';
export const template = stepper => {
    return {
        layout: {
            id: ROUTE.KYC_DOCUMENTS_UPLOAD_POI_MANUAL,
            type: LAYOUTS.LIST,
            widgets: [
                {
                    id: 'header',
                    type: WIDGET.HEADER,
                    position: POSITION.ABSOLUTE_TOP,
                },
                { id: 'topSpace', type: WIDGET.SPACE },
                { id: 'title', type: WIDGET.TEXT },
                { id: 'spaceSubTitle', type: WIDGET.SPACE },
                { id: 'subTitle', type: WIDGET.TEXT },
                { id: 'spaceSecondarySubTitle', type: WIDGET.SPACE },
                { id: 'secondarySubTitle', type: WIDGET.TEXT },
                { id: 'subTitleSpace', type: WIDGET.SPACE },
                { id: 'dropDownSpace', type: WIDGET.SPACE },
                { id: 'frontSide', type: WIDGET.DOCUMENT_PICKER },
                { id: 'frontSideSpace', type: WIDGET.SPACE },
                {
                    id: 'stackBottom',
                    type: WIDGET.STACK,
                    position: POSITION.ABSOLUTE_BOTTOM,
                },
            ],
        },
        datastore: {
            topSpace: { size: SizeTypeTokens.XXXL },
            dropDownSpace: { size: SizeTypeTokens.XXXL },
            frontSide: {
                titleLabel: 'Front side',
                ctaLabel: 'Upload',
                state: DocumentPickerState.DEFAULT,
                id: "pan_bt_front",
                action: {
                    type: ACTION.SELECT_DOCUMENT,
                    routeId: ROUTE.KYC_DOCUMENTS_UPLOAD_POI_MANUAL,
                    payload: {
                        value: { content: null, name: null },
                        widgetID: 'frontSide',
                    },
                },
            },
            frontSideSpace: { size: SizeTypeTokens.XXXL },
            header: {
                title: 'PAN Verification',
                type: HeaderTypeTokens.verification,
                stepperProps: {
                    data: stepper,
                    type: StepperTypeTokens.HORIZONTAL,
                },
                action: {
                    type: ACTION.GO_BACK,
                    routeId: ROUTE.KYC_DOCUMENTS_UPLOAD_POI_MANUAL,
                    payload: {},
                },
            },
            title: {
                label: 'Upload your PAN Card',
                color: ColorTokens.Grey_Night,
                fontSize: FontSizeTokens.MD,
                fontFamily: FontFamilyTokens.Poppins,
                fontWeight: '700',
                lineHeight: 20,
            },
            spaceSubTitle: { size: SizeTypeTokens.LG },
            spaceSecondarySubTitle: { size: SizeTypeTokens.LG },
            spaceInput: { size: SizeTypeTokens.XL },
            subTitle: {
                label: 'Supported document formats : PDF/PNG/JPEG',
                fontSize: FontSizeTokens.SM,
                color: ColorTokens.Grey_Charcoal,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                lineHeight: 18,
            },
            secondarySubTitle: {
                label: 'File size < 5 MB',
                fontSize: FontSizeTokens.SM,
                color: ColorTokens.Grey_Charcoal,
                fontFamily: FontFamilyTokens.Inter,
                fontWeight: '400',
                lineHeight: 18,
            },
            subTitleSpace: { size: SizeTypeTokens.XL },
            continue: {
                type: ButtonTypeTokens.LargeOutline,
                label: 'Confirm',
                width: ButtonWidthTypeToken.FULL,
                fontFamily: FontFamilyTokens.Inter,
                fontSize: FontSizeTokens.MD,
                lineHeight: SizeTypeTokens.XXL,
                fontWeight: '700',
                action: {
                    type: ACTION.TRIGGER_CTA,
                    routeId: ROUTE.KYC_DOCUMENTS_UPLOAD_POI_MANUAL,
                    payload: {},
                },
            },
            spaceContinue: { size: SizeTypeTokens.MD },
            stackBottom: {
                justifyContent: StackJustifyContent.center,
                alignItems: StackAlignItems.center,
                type: StackType.column,
                widgetItems: [
                    { id: 'continue', type: WIDGET.BUTTON },
                    // { id: "sbSpace1", type: WIDGET.SPACE },
                    // { id: "sbSpace2", type: WIDGET.SPACE },
                ],
            },
            sbSpace1: { size: SizeTypeTokens.XL },
            sbSpace2: { size: SizeTypeTokens.MD },
            image2: {
                name: IconTokens.Secure,
                size: IconSizeTokens.MD,
                color: ColorTokens.Secondary_100,
            },
            sbpace3: { size: SizeTypeTokens.MD },
        },
    };
};
export const kycDocumentUploadPOIManualMF = {
    onLoad: async ({ network }) => {
        const stepper = await horizontalStepperRepo(network);
        return Promise.resolve(template(stepper));
    },
    actions: {
        [ACTION.GO_BACK]: GoBackAction,
        [ACTION.SELECT_DOCUMENT]: documentPickerAction,
        [ACTION.ON_PAGE_LOAD]: onPageLoad,
        [ACTION.TRIGGER_CTA]: triggerAction,
    },
    action: {
        type: ACTION.ON_PAGE_LOAD,
        routeId: ROUTE.KYC_DOCUMENTS_UPLOAD_POI_MANUAL,
        payload: {},
    },
    clearPrevious: true,
};
